export const SHOPIFY_REMIX_LIBRARY_VERSION = '3.8.5';
